import styled from 'styled-components';

export const ScreenInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 3rem;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
`;

export const StatusBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2.4rem 0.4rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const StatusIcons = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
`;

export const ScreenHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2.4rem 1.2rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const ScreenTitle = styled.span`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  line-height: 1;
`;

export const ScreenHeaderAction = styled.span`
  font-size: 2.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.accent};
  line-height: 1;
`;

export const ScreenHeaderPill = styled.span`
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  padding: 0.6rem 1.1rem;
  border-radius: 999rem;
  font-size: 1.2rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
`;

export const ProfileContainer = styled.div`
  padding: 0 2.4rem 2.4rem;
  display: flex;
  flex-direction: column;
`;

export const AvatarSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 1.2rem;
  margin-bottom: 2rem;
`;

export const Avatar = styled.div`
  width: 8.4rem;
  height: 8.4rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.accent};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2rem;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 700;
  margin-bottom: 1.2rem;
  position: relative;
`;

export const AvatarEditBadge = styled.span`
  position: absolute;
  bottom: -0.2rem;
  right: -0.2rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.accent};
  border: 0.3rem solid ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  line-height: 1;
`;

export const ProfileName = styled.div`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.2rem;
`;

export const ProfileTitle = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: 0.8rem;
  text-transform: capitalize;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileStars = styled.div`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.amber};
  letter-spacing: 0.05rem;
`;

export const ProfileReviewCount = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.2rem;
`;

export const ProfileJoined = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.4rem;
`;

export const BadgeStrip = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-self: stretch;
  margin-top: 1.2rem;
  padding: 0 1.6rem;
  overflow-x: hidden;
`;

export const SubscriptionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.8rem;
  padding: 0.4rem 1.2rem;
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.2rem;
  font-weight: 700;
`;

export const RenewsLine = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.4rem;
`;

export const CvBanner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  margin-top: 1.2rem;
  margin-bottom: 1.6rem;
  padding: 1.2rem;
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.amberBgSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.amberSolid};
`;

export const CvBannerIcon = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 1;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.amberText};
`;

export const CvBannerText = styled.div`
  flex: 1;
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.amberText};
  line-height: 1.5;
`;

export const ShowAllToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 1rem 0;
  margin-bottom: 1.6rem;
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
`;

export const TabBar = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0.8rem 0 1.2rem;
  flex-shrink: 0;
`;

export const TabItem = styled.div<{ $active?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.accent : theme.colors.slateGrey};
`;

export const TabIcon = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 1;
`;

export const TabLabel = styled.span`
  font-size: 1rem;
  font-weight: 600;
`;

export const ProfileFlex = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const TrustBadgePill = styled.span<{
  $tone?: 'gold' | 'purple' | 'green' | 'blue';
}>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 999rem;
  border: 0.1rem solid;
  white-space: nowrap;

  ${({ $tone, theme }) => {
    const c = theme.colors;
    if ($tone === 'purple')
      return `background-color: ${c.trustBadgePurpleBg}; color: ${c.trustBadgePurpleFg}; border-color: ${c.trustBadgePurpleBorder};`;
    if ($tone === 'green')
      return `background-color: ${c.trustBadgeGreenBg}; color: ${c.trustBadgeGreenFg}; border-color: ${c.trustBadgeGreenBorder};`;
    if ($tone === 'blue')
      return `background-color: ${c.trustBadgeBlueBg}; color: ${c.trustBadgeBlueFg}; border-color: ${c.trustBadgeBlueBorder};`;
    return `background-color: ${c.trustBadgeGoldBg}; color: ${c.trustBadgeGoldFg}; border-color: ${c.trustBadgeGoldBorder};`;
  }}
`;

export const TrustBadgeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 1;
`;

export const SectionTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.8rem;
  margin-top: 1.6rem;
`;

export const ServicesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const ServiceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1.4rem 1.6rem;
  gap: 1.2rem;
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const ServiceMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ServiceName = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ServicePriceNote = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ServicePrice = styled.span`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
  background-color: ${({ theme }) => theme.colors.accentBgSoft};
  padding: 0.5rem 1rem;
  border-radius: 999rem;
  white-space: nowrap;
`;

export const SegmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1.2rem 2.4rem 0.8rem;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border-radius: 1rem;
  padding: 0.3rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  gap: 0.3rem;
`;

export const SegmentButton = styled.span<{ $active?: boolean }>`
  flex: 1;
  padding: 0.8rem;
  text-align: center;
  border-radius: 0.8rem;
  font-size: 1.4rem;
  font-weight: 600;
  ${({ $active, theme }) =>
    $active
      ? `background-color: ${theme.colors.white}; color: ${theme.colors.darkSlate}; box-shadow: 0 0.1rem 0.2rem rgba(0,0,0,0.1);`
      : `color: ${theme.colors.slateGrey};`}
`;

export const ReviewsScroll = styled.div`
  padding: 2.4rem 2.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const ReviewCard = styled.div`
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border-radius: 1.2rem;
  padding: 1.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  display: flex;
  flex-direction: column;
`;

export const ReviewMetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: 0.6rem;
`;

export const ReviewServiceTag = styled.span`
  color: ${({ theme }) => theme.colors.accent};
  font-weight: 700;
`;

export const ReviewCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
  gap: 0.8rem;
`;

export const ReviewerName = styled.span`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  flex-shrink: 1;
`;

export const ReviewStars = styled.span`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.amber};
  flex-shrink: 0;
  letter-spacing: 0.05rem;
`;

export const ReviewDate = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: 0.8rem;
  display: block;
`;

export const VerifiedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.3rem;
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.successText};
  background-color: ${({ theme }) => theme.colors.successBgSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.successBorder};
  padding: 0.2rem 0.6rem;
  border-radius: 0.6rem;
  margin-bottom: 0.6rem;
`;

export const ReviewComment = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
`;

export const WeekStrip = styled.div`
  display: flex;
  gap: 0.8rem;
  padding: 1.2rem 1.2rem 0.8rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  justify-content: space-between;
`;

export const DayCell = styled.div<{
  $state?: 'default' | 'selected' | 'pending' | 'accepted';
}>`
  flex: 1;
  height: 5.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  border-radius: 1.8rem;
  font-size: 1.1rem;
  font-weight: 600;

  ${({ $state, theme }) => {
    if ($state === 'selected')
      return `background-color: ${theme.colors.accent}; color: ${theme.colors.white};`;
    if ($state === 'pending')
      return `background-color: ${theme.colors.amberBorder};`;
    if ($state === 'accepted')
      return `background-color: ${theme.colors.successBorder};`;
    return '';
  }}
`;

export const DayLetter = styled.span<{ $selected?: boolean }>`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.white : theme.colors.slateGrey};
`;

export const DayNumber = styled.span<{ $selected?: boolean }>`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.white : theme.colors.darkSlate};
`;

export const TodayDot = styled.span`
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.accent};
  margin-top: 0.2rem;
`;

export const DateLabel = styled.div`
  padding: 1.2rem 2.4rem 0.6rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TimelineRow = styled.div<{ $booked?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0.8rem 1.2rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  ${({ $booked, theme }) =>
    $booked ? `background-color: ${theme.colors.accentLight};` : ''}
`;

export const TimeLabel = styled.span`
  width: 5.2rem;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  padding-top: 0.2rem;
  flex-shrink: 0;
`;

export const SlotLine = styled.span`
  width: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border};
  align-self: stretch;
  margin: 0 0.8rem;
`;

export const SlotContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const AvailableText = styled.span`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  font-style: italic;
`;

export const BookingCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1rem;
  padding: 1.2rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  display: flex;
  flex-direction: column;
`;

export const BookingTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
`;

export const BookingClientName = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  flex: 1;
`;

export const BookingServiceLabel = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.accent};
  margin-bottom: 0.4rem;
`;

export const BookingPhone = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.4rem;
`;

export const StatusBadgeInline = styled.span<{
  $tone?: 'pending' | 'accepted';
}>`
  align-self: flex-start;
  padding: 0.2rem 0.8rem;
  border-radius: 1.2rem;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: capitalize;
  border: 0.1rem solid;

  ${({ $tone, theme }) =>
    $tone === 'accepted'
      ? `background-color: ${theme.colors.successBg}; color: ${theme.colors.successText}; border-color: ${theme.colors.successBorder};`
      : `background-color: ${theme.colors.amberBg}; color: ${theme.colors.amberText}; border-color: ${theme.colors.amberBorder};`}
`;

export const BookingActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  margin-top: 0.8rem;
`;

export const ActionButton = styled.span<{ $tone?: 'accept' | 'reject' }>`
  flex: 1;
  text-align: center;
  padding: 0.8rem;
  border-radius: 0.8rem;
  font-size: 1.3rem;
  font-weight: 700;
  border: 0.1rem solid;

  ${({ $tone, theme }) =>
    $tone === 'reject'
      ? `background-color: ${theme.colors.errorBg}; color: ${theme.colors.errorRed}; border-color: ${theme.colors.errorBorder};`
      : `background-color: ${theme.colors.successBg}; color: ${theme.colors.successText}; border-color: ${theme.colors.successBorder};`}
`;
